var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products.length === 0)?_c('div',{staticClass:"no-result"},[_vm._v("نتیجه‌ای یافت نشد!")]):_c('div',[(_vm.type === 'grid')?_c('ul',{staticClass:"grid-items"},_vm._l((_vm.products),function(product,index){return _c('li',{key:product[index]},[_c('ProductItem',{attrs:{"product":product}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }